import axiosConfig from '../../config/axiosConfig';
import {
  GET_QR_JWT_TOKEN,
  QR_JWT_TOKEN_SUCCESS,
  QR_JWT_TOKEN_ERROR,
  REFRESH_QR_TOKEN,
  REFRESH_QR_TOKEN_SUCCESS,
  REFRESH_QR_TOKEN_ERROR,
} from '../dispatchTypes';

export const getQrJwtToken = dispatch => {
  dispatch({ type: GET_QR_JWT_TOKEN });
  return axiosConfig
    .post(
      '/qr_code/auth',
      {},
      {
        headers: {
          'X-ICTLIFE-APPLICATION': undefined,
          'X-CLIENT-IDENTIFIER': undefined,
        },
      }
    )
    .then(response => {
      dispatch({
        type: QR_JWT_TOKEN_SUCCESS,
        data: response.data,
      });
    })
    .catch(error => {
      dispatch({
        type: QR_JWT_TOKEN_ERROR,
        error: error.response.data,
      });
    })
    .catch(() => {
      dispatch({
        type: QR_JWT_TOKEN_ERROR,
        error: 'lost connection to the server',
      });
    });
};

export const refreshQrToken = (dispatch, body) => {
  dispatch({ type: REFRESH_QR_TOKEN });
  return axiosConfig
    .post('/qr_code/refresh', body, {
      headers: {
        'X-ICTLIFE-APPLICATION': undefined,
        'X-CLIENT-IDENTIFIER': undefined,
      },
    })
    .then(response => {
      dispatch({
        type: REFRESH_QR_TOKEN_SUCCESS,
        data: response.data,
      });
    })
    .catch(error => {
      dispatch({
        type: REFRESH_QR_TOKEN_ERROR,
        error: error.response.data,
      });
    })
    .catch(() => {
      dispatch({
        type: REFRESH_QR_TOKEN_ERROR,
        error: 'lost connection to the server',
      });
    });
};

export const initiateQrLogin = async payload => {
  const response = await axiosConfig.post('/qr_code/sessions', payload);
  return response;
};
